import React, { Component } from 'react';
import Helmet from 'react-helmet';
import request from 'superagent';
import Youtube from 'react-youtube';
import Modal from 'react-modal';
import SupportNav from './SupportNav';
import tree from '../../state';
import config from '../../config';
import Header from '../common/Header';
import Breadcrumb from '../common/Breadcrumb';
import BreadcrumbItem from '../common/BreadcrumbItem';

const customStyles = {
	overlay: {
		backgroundColor: 'rgba(0,0,0,0.75)',
		zIndex: 999
	},
	content: {
		top: '50%',
		left: '50%',
		right: 'auto',
		bottom: 'auto',
		marginRight: '-50%',
		borderRadius: '4px',
		border: 'none',
		background: 'transparent',
		transform: 'translate(-50%, -50%)',
		overflow: 'hidden',
		width: 640,
		maxWidth: 'calc(100% - 40px)'
	}
};

class CheckSafeLanding extends Component {
	constructor(props) {
		super(props);
		this.state = {
			active: false,
			srNumber: false,
			srRegex: true,
			modalOpen: false,
		};
	}
	
	checkSerialNumber() {
		const serialRegex = /^[a-zA-Z]*[0-9]*\*$/;
		
		if (serialRegex.test(this.refs.serialNumber.value)) {
			request.get(`/api/checkserialnumber/${this.refs.serialNumber.value}`)
			.set('authorization', tree.get('token'))
			.then(res => JSON.parse(res.text))
			.then(res => {
				this.setState({
					active: true,
					srRegex: true,
					srNumber: res.serialNumber
				});
			});
		} else {
			this.setState({
				active: false,
				srRegex: false,
				srNumber: false
			});
		}
	}

	openModal() {
		this.setState({ modalOpen: true });
	}

	closeModal() {
		this.setState({ modalOpen: false });
	}

	render() {
		let inCorrectInput;
		let affected;
		const pdfPath = `${config.contentUrl}/sentrysafe/resources/pdf/`;
		console.log(pdfPath);
		
		if (!this.state.srRegex) {
			inCorrectInput = (
				<div className="alert incorrect">
					<p>
						The serial number must begin with an alpha character and end
						with an asterisk &#40;&#42;&#41;. Please double&#45;check
						your safe and try again.
					</p>
				</div>
			);
		}
	
		if (this.state.active) 	{
			if (this.state.srNumber) {
				affected = (
					<div className="alert affected">
						<p>Your safe is affected.</p>
						<p>
							<a
								className="arrow-link"
								href={ `${pdfPath}Letter-to-SS-Customers.pdf` }
								target="_blank"
							>
								Please click here to view our letter
							</a>
						</p>
						<button
							className="btn btn-primary"
							onClick={ e => this.openModal(e) }
						>
							Install Your Upgrade Kit
						</button>
						<Modal
							isOpen={ this.state.modalOpen }
							onRequestClose={ () => this.closeModal() }
							style={ customStyles }
							contentLabel="Modal"
						>
							<button
								className="ReactModal__close"
								onClick={ () => this.closeModal() }
							>
								<span className="fa fa-times" aria-hidden="true" />
								<span className="assistive-text">close</span>
							</button>
							<div className="embed-responsive-16x9">
								<Youtube
									videoId="eYWIUP_ENn0"
									opts={{ playerVars: { rel: 0 } }}
								/>
							</div>
							<div className="modal-instructions">
								<p>
									SentrySafe was made aware that our line of digital
									fire-resistant safes were vulnerable to theft by means of a rare
									earth magnet. While these magnets are regulated, difficult to transport
									and must be used by a skilled locksmith, SentrySafe
									wanted to give you and the rest of our consumers the opportunity to
									upgrade your safe to defend against this potential risk.
								</p>
								<a
									href={ `${pdfPath}519454-Upgrade-Kit-Install-1.23.pdf` }
									target="_blank"
								>
									Download 1.2 Kit Instructions
								</a><br />
								<a
									href={ `${pdfPath}519456-Upgrade-Kit-Install-2.0.pdf` }
									target="_blank"
								>
									Download .8 and 2.0 Kit Instructions
								</a>
							</div>
						</Modal>
					</div>
				);
			} else {
				affected = (
					<div className="alert not-affected">
						<p>Your safe is not affected.</p>
						<p>There are no further steps.</p>
					</div>
				);
			}
		}
		return (
			<div className="check-your-safe">
				<Helmet>
					<title>Check Your Safe &#124; SentrySafe</title>
					<meta name="description" content="We have an important message from our engineers that may affect your electronic fire safe. Check your safe online for more information." />
				</Helmet>

				<Breadcrumb>
					<BreadcrumbItem label="Support" path="/support" />
					<BreadcrumbItem label="Check Your Electronic Fire Safe" />
				</Breadcrumb>

				<SupportNav />

				<Header title="Check Your Electronic Fire Safe" />

				<div className="content">
					<div className="row">
						<div className="col sm-12">
							<h2 className="title">Enter Your Serial Number</h2>
							<p>Enter the serial number of your electronic fire safe in the space provided below to determine if you need to read an important message from our engineers. The serial number can be found on a label adhered to the front of your unit or inside on the door.</p>
							<p className="note"><span>Note&#58;</span> Be sure to enter all of the information, including any letters preceding the number and the asterisk at the end.</p>
							<p className="note">Example&#58; C12345678&#42;</p>
						</div>
					</div>
					<div className="row info">
						<div className="col sm-5 form">
							<label htmlFor="serialNumber">
								Enter Your Safe&rsquo;s Serial Number
							</label>
							<input
								type="text"
								placeholder="Example: C12345678*"
								className="form-control"
								id="serialNumber"
								name="serialNumber"
								ref="serialNumber"
							/>
							<input
								type="submit"
								className="btn btn-primary"
								onClick={ () => this.checkSerialNumber() }
								value="Check Serial Number"
							/>
							{ inCorrectInput }
							{ affected }
						</div>
						<div className="col sm-7 serial-location">
							<h3>Serial Number Location</h3>
							<img
								alt="Serial Number Locations"
								src={ require('../../resources/img/callouts/safe-labels.png') }
							/>
						</div>
					</div>
				</div>
			</div>
		);
	};
};

export default CheckSafeLanding;


// WEBPACK FOOTER //
// ./src/pages/support/checkSerialNumber.js